/* eslint-disable import/prefer-default-export */
import { artistRepsCredentialsUrl } from '../urls';
import refresh from '../refresh';

export async function patchArtistRepsCredentialsRevoked(credentialId) {
  const data = {
    credential: credentialId,
  };
  return refresh(async () => {
    const response = await fetch(artistRepsCredentialsUrl, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}
